import React from 'react';

import { Utils } from '@adobe/aem-react-editable-components';
import { useAuth } from 'context/Auth';
import { Route } from 'react-router-dom';

import { LoadingIndicator } from 'components/LoadingIndicator/LoadingIndicator';

import { logoutWithRedirect } from 'utils/AuthUtils';

export const PrivateRoute = (props) => {
  const { isAuthenticated, isLoading, isCIAM } = useAuth();
  const isEditor = Utils.isInEditor();
  if (isEditor) {
    return <Route {...props} />;
  }
  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (!isAuthenticated) {
    logoutWithRedirect(isCIAM);
  }

  return <Route {...props} />;
};
